import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21dd2b51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-home me-2" }),
    /*#__PURE__*/_createTextVNode("ระบบฐานข้อมูลสารสนเทศในการกำกับและติดตามการปฏิบัติราชการในภูมิภาค")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงสรุปข้อมูลการดำเนินการโครงการทั้งหมด")
], -1))
const _hoisted_3 = { class: "card-body mt-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "input-group mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins" })
], -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "input-group mb-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt" })
], -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = { class: "card card-sub mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-users me-2" }),
  /*#__PURE__*/_createTextVNode("คณะ ร.นรม/รมต.นร. ")
], -1))
const _hoisted_15 = { class: "card-body pt-0" }
const _hoisted_16 = { class: "list-group list-group-flush" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row p-0" }
const _hoisted_19 = { class: "col-auto ps-0" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "col pe-0" }
const _hoisted_22 = { class: "no-bullets" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }, null, -1))
const _hoisted_24 = { class: "d-flex justify-content-start wraper" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "card card-sub mb-3" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = {
  class: "mb-2",
  style: {"height":"50px"}
}
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }, null, -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_35 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_36 = {
  ref: "thaiMap",
  class: "jvector-map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_DashboardComponent = _resolveComponent("DashboardComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected.fiscalYearId) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fiscalYearChange && _ctx.fiscalYearChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalYears, (fiscalYear) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: fiscalYear.id,
                  value: fiscalYear.id
                }, _toDisplayString(fiscalYear.name), 9, _hoisted_7))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selected.fiscalYearId]
            ])
          ]),
          (_ctx.cabinetsByFiscalYear.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected.cabinetId) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cabinetChange && _ctx.cabinetChange(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinetsByFiscalYear, (cabinet) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: cabinet.id,
                      value: cabinet.id
                    }, _toDisplayString(_ctx.cabinetLabel(cabinet)), 9, _hoisted_10))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selected.cabinetId]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("ul", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinetMinisters, (element, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: _normalizeClass(["list-group-item list-group-item-action list-hover", {active: element.id === _ctx.selected.cabinetMinisterId}]),
                      onClick: _withModifiers(($event: any) => (_ctx.ministerClick(element.id)), ["stop","prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("img", {
                            class: "photo-image",
                            src: element.minister.photo,
                            width: "60",
                            height: "70",
                            alt: "preview"
                          }, null, 8, _hoisted_20)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("ul", _hoisted_22, [
                            _createElementVNode("li", null, [
                              _hoisted_23,
                              _createTextVNode(_toDisplayString(element.minister.fullName), 1)
                            ]),
                            _createElementVNode("li", null, _toDisplayString(element.position.name), 1),
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_24, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.regions, (region) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: region.id,
                                    class: _normalizeClass(["btn btn-sm me-1", {
                                  'btn-primary': _ctx.selected.regionId !== region.id,
                                  'btn-warning': _ctx.selected.regionId === region.id
                                }]),
                                    onClick: _withModifiers(($event: any) => (_ctx.regionClick(element.id, region.id)), ["stop","prevent"])
                                  }, _toDisplayString(region.shortName), 11, _hoisted_25))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ], 10, _hoisted_17))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _hoisted_31,
                    _createTextVNode(_toDisplayString(_ctx.info.title), 1)
                  ]),
                  (_ctx.selected.regionId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinces, (province) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: province.id,
                            class: _normalizeClass(["btn btn-sm me-1", {
                        'btn-primary ': _ctx.selected.provinceId !== province.id,
                        'btn-warning': _ctx.selected.provinceId === province.id
                      }]),
                            onClick: _withModifiers(($event: any) => (_ctx.provinceClick(province.id)), ["stop","prevent"])
                          }, _toDisplayString(province.name), 11, _hoisted_33))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.info.description), 1))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, null, 512)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : (_openBlock(), _createBlock(_component_DashboardComponent, {
          key: 1,
          "fiscal-year-id": _ctx.selected.fiscalYearId,
          "cabinet-id": _ctx.selected.cabinetId,
          "cabinet-minister-id": _ctx.selected.cabinetMinisterId,
          "minister-id": _ctx.selected.ministerId,
          "appointment-region-id": _ctx.selected.appointmentRegionId,
          "region-id": _ctx.selected.regionId,
          "province-id": _ctx.selected.provinceId
        }, null, 8, ["fiscal-year-id", "cabinet-id", "cabinet-minister-id", "minister-id", "appointment-region-id", "region-id", "province-id"]))
  ], 64))
}